<template>
	<type-wrapper class="type-H" :padding="0">
		<type-grid row="11" v-if="showData.url">
			<vue-video :src="showData.url" :breakpoint="time" :title="showData.title || ''" :subtitle="showData.subtitle || ''" @break-play="breakPlay"></vue-video>
		</type-grid>
		<type-grid row="11" margin v-else-if="showData.audio_url">
			<vue-audio :src="showData.audio_url" :name="showData.title" :photo="showData.photo"></vue-audio>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 音视频框
	import mixin from '../mixin.js'
	import vueAudio from './vue-audio.vue'
	import vueVideo from './vue-video.vue'
	export default {
		name: 'type-H',
		mixins: [ mixin ],
		data() {
			return {
				time: -1
			}
		},
		created() {
			const userInfo = this.$userInfo.getData();
			if (!userInfo.name) {
				this.time = process.env.NODE_ENV === 'production' ? 15 : 2;
			}
		},
		methods: {
			breakPlay(data) {
				this.$contact().then(res => this.time = -1);
			}
		},
		components: {
			'vue-audio': vueAudio,
			'vue-video': vueVideo
		}
	}
</script>

<style scoped lang="less">
	.type-H{
		padding: 0;
	}


</style>
